<template>
  <WfVariableAlias v-if="isAlias" :name="linkedVariable.name" />
  <WfColorVariable v-else-if="variable.type === 'COLOR'" :mode="resolvedMode" />
  <WfNumberVariable
    v-else-if="variable.type === 'LENGTH'"
    :variable="variable"
    :mode="resolvedMode"
  />
  <WfTypography v-else :mode="resolvedMode" />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

import WfColorVariable from './WfColorVariable.vue';
import WfTypography from './WfTypography.vue';
import WfNumberVariable from './WfNumberVariable.vue';
import WfVariableAlias from './WfVariableAlias.vue';

const store = useStore();

const props = defineProps({
  variable: {
    type: Object,
    required: true,
  },
  mode: {
    type: Object,
    required: true,
  },
});

const isAlias = computed(() => props.mode.value.type === 'VARIABLE_ALIAS');

const linkedVariable = computed(() => {
  return store.getters['variable/variableMap'].get(props.mode.value.parentVariableId);
});

const resolvedMode = computed(() => {
  if (isAlias.value) {
    return {
      ...props.mode,
      value: props.mode.value.resolvedValue,
    };
  }

  return props.mode;
});
</script>
